import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function GlobeIcon(t0) {
  const $ = _c(7);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M17.302 20.463c1.181-1.936 1.941-4.536 2.085-7.463h2.562c-.302 3.038-1.976 5.671-4.386 7.293l-.261.17zM2.051 13h2.563c.143 2.927.905 5.527 2.085 7.464-2.462-1.549-4.21-4.131-4.61-7.14L2.05 13zm4.648-9.464C5.519 5.472 4.757 8.073 4.614 11H2.051c.303-3.038 1.977-5.673 4.387-7.294l.261-.17zM13 11V2.185c2.304.833 4.142 4.459 4.389 8.815H13zm0 10.815V13h4.389c-.24 4.245-1.992 7.797-4.213 8.745l-.176.07zM11 13v8.815C8.697 20.983 6.859 17.357 6.612 13H11zm0-10.814V11H6.612c.24-4.244 1.992-7.796 4.212-8.745L11 2.186zM21.949 11h-2.562c-.143-2.927-.904-5.527-2.085-7.463 2.462 1.548 4.21 4.131 4.61 7.14l.037.323zM12 0C5.384 0 0 5.383 0 12s5.384 12 12 12c6.617 0 12-5.383 12-12C24 5.485 18.781.166 12.305.004L12 0z" fill="black" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== className || $[5] !== props) {
    t2 = <svg aria-hidden={true} className={className} height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>{t1}</svg>;
    $[4] = className;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}